var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { useEffect, useState } from 'react';
import { useEventListener } from './useEventListener';
/**
 * Gets the dimensions of the viewport
 *
 * @param {Breakpoints} [breakpoints] Definitions of specific device breakpoints
 * @example
 * const { height, width, mobile } = useViewPort();
 * console.log(`Your viewport is ${mobile ? 'below' : 'above'} mobile (${width}x${height})`);
 */
export var useViewPort = function (breakpoints) {
    var _a = useState({
        width: globalThis.document.documentElement.clientWidth,
        height: globalThis.document.documentElement.clientHeight,
    }), size = _a[0], setSize = _a[1];
    var _b = useState({
        width: globalThis.window.innerWidth,
        height: globalThis.window.innerHeight,
    }), withScrollbar = _b[0], setWithScrollbar = _b[1];
    var _c = useState((breakpoints === null || breakpoints === void 0 ? void 0 : breakpoints.mobile) ? globalThis.document.documentElement.clientWidth <= (breakpoints === null || breakpoints === void 0 ? void 0 : breakpoints.mobile) : false), mobile = _c[0], setMobile = _c[1];
    var _d = useState((breakpoints === null || breakpoints === void 0 ? void 0 : breakpoints.mobile) ? globalThis.window.innerWidth <= (breakpoints === null || breakpoints === void 0 ? void 0 : breakpoints.mobile) : false), mobileWithScrollbar = _d[0], setMobileWithScrollbar = _d[1];
    useEffect(function () {
        if (breakpoints === null || breakpoints === void 0 ? void 0 : breakpoints.mobile) {
            setMobile(globalThis.document.documentElement.clientWidth <= breakpoints.mobile);
            setMobileWithScrollbar(globalThis.window.innerWidth <= breakpoints.mobile);
        }
    }, [withScrollbar.width, breakpoints.mobile]);
    useEventListener('resize', function () {
        setSize({ width: globalThis.document.documentElement.clientWidth, height: globalThis.document.documentElement.clientHeight });
    });
    useEventListener('orientationchange', function () {
        return setSize({ width: globalThis.document.documentElement.clientWidth, height: globalThis.document.documentElement.clientHeight });
    });
    useEventListener('resize', function () { return setWithScrollbar({ width: globalThis.window.innerWidth, height: globalThis.window.innerHeight }); });
    useEventListener('orientationchange', function () { return setWithScrollbar({ width: globalThis.window.innerWidth, height: globalThis.window.innerHeight }); });
    return __assign(__assign({}, size), { mobile: mobile, withScrollbar: __assign(__assign({}, withScrollbar), { mobile: mobileWithScrollbar }) });
};
